<template>
  <div class="footer_menu">
    <span v-for="menu in menus" :key="menu.label">
      <FooterMenu
        :url="menu.url"
        :image="menu.image"
        :label="menu.label"
        @handleClick="handleClick"
      />
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FooterMenu from '@/components/atoms/FooterMenu.vue';

export default {
  components: {
    FooterMenu,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  data: () => ({
    menus: [
      {
        url: '/',
        image: '/img/menu/home.png',
        label: 'HOME',
      },

      {
        url: '/buy-point',
        image: '/img/dorima-icon-coin.png',
        label: 'Point',
      },

      {
        url: '',
        image: '/img/menu/mypage.png',
        label: 'My Page',
        isTransition: false,
      },
    ],
  }),

  methods: {
    handleClick(label) {
      if (label === 'My Page') {
        this.$store.dispatch('user/setShowMyPage', true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.footer_menu {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 1000;
  width: -webkit-fill-available;
  z-index: 1;
  background-color: #fff;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 5px;
  padding: 5px;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 2.1);
  z-index: 10;
}
</style>
